import { Schema } from '../../squidex/models/schema.model';

export class DynamicSchemaModel extends Schema {

  constructor(schema?: Partial<Schema>) {
    super(schema);
  }
}
